import {AppState} from '../../store';
import {ITableCell} from '../../../@crema/components/Table/TableItem';
import {format} from 'date-fns';
import {getAdminData} from '../Admin';

export const getTokenEmissionIsBurning = (state: AppState) =>
  state.token.emissions.isBurning;

export const getTokenEmissionIsMinting = (state: AppState) =>
  state.token.emissions.isMinting;

export const getTokenEmissions = (state: AppState) => state.token.emissions;

export const getTokenEmissionsRows = (state: AppState): Array<ITableCell[]> => {
  const admins = getAdminData(state);
  const {emissions} = state.token;
  const emissionRows: Array<ITableCell[]> = [];
  emissions.data &&
    emissions.data.map((emission) => {
      emissionRows.push([
        {
          value:
            emission.type === 'mint'
              ? `+${emission.amount}`
              : `-${emission.amount}`,
        },
        {
          value: (() => {
            if (admins && admins.length) {
              const indexOf = admins.findIndex(
                (admin) => admin.address === emission.actor.toLowerCase(),
              );
              if (indexOf !== -1) {
                return admins[indexOf].email ?? emission.actor;
              } else {
                return emission.actor;
              }
            } else {
              return emission.actor;
            }
          })(),
        },
        {
          value: emission.txHash,
          link: `${process.env.REACT_APP_ETHERSCAN_BASE_URL}/tx/${emission.txHash}`,
        },
        {
          value: format(
            new Date(emission.timestamp * 1000),
            'H:mm  d MMMM yyyy',
          ),
        },
      ]);
    });

  return emissionRows;
};
